'use client'

import { MotionConfig } from 'motion/react'
import { ThemeProvider } from 'next-themes'
import { NuqsAdapter } from 'nuqs/adapters/next/app'
import { type ReactNode, Suspense } from 'react'

import { ThemeToaster } from '@/components/theme-toaster'
import { ConfirmDialogProvider } from '@/components/ui/confirm-dialog'
import { PointerEventsGuard } from '@/components/ui/pointer-events-guard'

/**
 * `reducedMotion="user"`: when the OS asks for less motion, every Motion
 * component drops transform and layout animation and keeps its fades. The
 * CSS side (tw-animate overlays) is handled in packages/ui/src/motion.css.
 */
export function RootProviders({ children }: { children: ReactNode }) {
  return (
    <MotionConfig reducedMotion="user">
      <NuqsAdapter>
        <ThemeProvider
          attribute="class"
          defaultTheme="system"
          enableSystem
          disableTransitionOnChange
        >
          <ConfirmDialogProvider>{children}</ConfirmDialogProvider>
          <Suspense fallback={null}>
            <ThemeToaster />
          </Suspense>
          <PointerEventsGuard />
        </ThemeProvider>
      </NuqsAdapter>
    </MotionConfig>
  )
}
